/**
 * Sections 4–11 — Remaining Privacy Policy sections
 * Exact legal text from the approved Privacy Policy prototype.
 */

import { BulletPoint } from '../BulletPoint';

export const RemainingSections = () => (
  <div className="font-termina text-xl max-md:text-2xl">
    {/* Section 4 */}
    <h2 className="font-recoleta font-black">
      4. Accessing Your Information and Opt-in/Opt-out Requests
    </h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        To help you review, edit, and control how we use much of the information
        we collect about you, you can visit your account settings webpage. You
        may unsubscribe from marketing communications by following the link at
        the bottom of the relevant email. You cannot, however, unsubscribe from
        receiving certain emails, such as account status and billing related
        emails, unless you close your Membership and fulfill any existing
        contractual obligations.
      </div>
    </span>
    <br /><br />
    <span className="flex">
      <div className="w-full font-termina">
        If you choose to opt out of the collection and use of certain of your
        information or request deletion of your personal information, you
        understand that some services may no longer be available to you,
        potentially requiring the cancelation of your subscription or
        Membership. Please state in your correspondence the details of your
        request. We may require proof of your identity before we provide you
        with the requested information. We may retain certain personal
        information as required by law, to protect bQuest from legal claims, or
        for administrative records.
      </div>
    </span>
    <br /><br />

    {/* Section 5 */}
    <h2 className="font-recoleta font-black">
      5. Data Security, Integrity, and Access
    </h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        The personal information you provide and we collect is stored within
        databases that we control directly or through our Administrative
        Providers. As we deem appropriate and as required by the applicable law,
        we use security measures appropriate for the sensitivity of the personal
        information and consistent with industry standards, including physical,
        organizational and technological protections, such as firewalls, to
        protect your personal information. We also use industry standard
        encryption technology to protect payment card and password information.
        However, since no security system is impenetrable, we cannot guarantee
        the security of our databases, nor can we guarantee that information you
        supply will not be intercepted while being transmitted to us over the
        Internet. Personal information may only be accessed by persons within
        our organization, our third party Providers who require such access to
        provide you with the Services you request, or any other party that you
        have provided us with authorization to share such information with.
      </div>
    </span>
    <br /><br />
    <span className="flex">
      <div className="w-full font-termina">
        We retain personal information that we collect only as long as
        reasonably necessary to fulfill the purposes for which it was collected
        or to otherwise meet any legal requirements.
      </div>
    </span>
    <br /><br />
    <span className="flex">
      <div className="w-full font-termina">
        Your information may be transferred to, and maintained on, computers
        located outside of your state, province/territory, or country where the
        privacy laws may not be as protective as those where you live. If you
        are located outside the United States and choose to provide information
        to us, please be aware that we transfer personal information to the
        United States and process and store it there. As a result, this
        information may be subject to access requests from governments, courts,
        law enforcement officials and national security authorities in the
        United States according to its laws. Subject to the applicable laws, we
        will use reasonable efforts to ensure that appropriate protections are
        in place to maintain protections on the personal information.
      </div>
    </span>
    <br /><br />
    <span className="flex">
      <div className="w-full font-termina">
        By submitting your personal information, you consent to having your
        personal data transferred to, processed, and stored in the United
        States. Your username(s) and password(s) may only be used by you. You
        may not share any username and password with anyone else except the
        applicable Provider, and you are solely responsible for maintaining and
        protecting the confidentiality of each username and password. You are
        fully responsible for all activities that occur under any of your
        usernames and passwords. You can access and update your login
        information in your account's settings.
      </div>
    </span>
    <br /><br />

    {/* Section 6 */}
    <h2 className="font-recoleta font-black">6. Payment Information</h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        We share payment information with trusted third parties to bill you for
        our Services. We use third parties for secure credit card transaction
        processing, and we send billing information to those third parties to
        process your orders and payments or to validate your credit card
        information on file. Certain Providers may require you to pay outside of
        the Services; in those cases, the Provider's payment terms will apply.
      </div>
    </span>
    <br /><br />

    {/* Section 7 */}
    <h2 className="font-recoleta font-black">
      7. Third Party Websites and Links
    </h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        When you click on links (including advertising banners), which take you
        to third party websites, including those of Providers, you will be
        subject to their privacy policies. While we support the protection of
        your privacy on the internet, bQuest expressly disclaims any and all
        liability for the actions of third parties, including without limitation
        to actions relating to the use and/or disclosure of personal information
        by third parties, including Providers.
      </div>
    </span>
    <br /><br />
    <span className="flex">
      <div className="w-full font-termina">
        Our Services may contain links to websites operated by third parties.
        bQuest does not control such other sites and is not responsible for
        their content, their privacy policies, or their use of personal
        information. bQuest's inclusion of such links does not, by itself, imply
        any endorsement of the content on such sites or of their owners or
        operators except as disclosed on the Services. Any information submitted
        by you directly to these third parties is subject to that third party's
        privacy policy.
      </div>
    </span>
    <br /><br />

    {/* Section 8 */}
    <h2 className="font-recoleta font-black">8. Children's Privacy</h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        bQuest does not intend the Services to be used by individuals under 18.
        We do not seek or knowingly collect any personal information about
        persons under 18 years of age. If we become aware that we have
        unknowingly collected personal information from a child under the age of
        18, we will make commercially reasonable efforts to delete such
        information from our database. If you are the parent or guardian of a
        minor child who has provided us with personal information, you may
        contact us using the information below to request it be deleted.
      </div>
    </span>
    <br /><br />

    {/* Section 9 */}
    <h2 className="font-recoleta font-black">9. Governing Law</h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        This Privacy Policy and the privacy practices of bQuest will be subject
        exclusively to the laws of the state of Colorado.
      </div>
    </span>
    <br /><br />

    {/* Section 10 */}
    <h2 className="font-recoleta font-black">
      10. Your California Privacy Rights
    </h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        This privacy policy describes how we may share your information for
        marketing purposes. It applies to all bQuest customers, including
        California residents:
      </div>
    </span>
    <br /><br />

    <BulletPoint>
      We share information with others as more fully set forth above in
      Disclosures and Transfers of Information.
      <br />
    </BulletPoint>
    <br />
    <BulletPoint>
      We share your information with other parts of our business and with our
      Providers. See above: Disclosures and Transfers of Information.
      <br />
    </BulletPoint>
    <br />

    {/* Section 11 */}
    <h2 className="font-recoleta font-black">11. How to Contact Us</h2>
    <br />
    <span className="flex">
      <div className="w-full font-termina">
        For all requests, questions, concerns, or complaints about your personal
        information or this Privacy Policy, please contact our Privacy Officer
        by mail or email at the following:
        <br /><br />
        info@thebQuest.com
        <br />
        Attn: Privacy Officer
        <br />
        bQuest
        <br />
        865 North Albion St, Suite 250
        <br />
        Denver, CO 80220
      </div>
    </span>
    <br /><br />
  </div>
);
